import { Location } from '@angular/common';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { generateUUID } from 'src/app/core/generators/generateUUID';
import { IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca } from 'src/app/services/CaminhaoService/caminhao.model';
import { CaminhaoService } from 'src/app/services/CaminhaoService/caminhao.service';
import { ICreateMovimentacaoPaleteEntradaBody } from 'src/app/services/PaleteService/palete.model';
import { PaleteService } from 'src/app/services/PaleteService/palete.service';
import { SwalAlertService } from 'src/app/services/SwalAlertService/swalAlert.service';

type IOptions = {
  name: string;
  value: string | number;
};

type typeAgendamentoOrCavalo = 'Agendamento' | 'Cavalo';
@Component({
  selector: 'app-cadastro-entrada-estacionamento-tpg',
  templateUrl: './cadastro-entrada-estacionamento-tpg.component.html',
  styleUrls: ['./cadastro-entrada-estacionamento-tpg.component.scss']
})
export class CadastroEntradaEstacionamentoTpgComponent implements OnInit {
  form: FormGroup;
  id = localStorage.getItem('id');
  isViewing: boolean = false;
  isLoading: boolean = false;
  carretasSelecionadas: string = 'Selecione';
  guid = generateUUID();

  carretaOptions: IOptions[] = [];

  itemOptions: IOptions[] = [
    {
      name: 'Palete',
      value: 1
    },
    {
      name: 'Lona',
      value: 2
    },
    {
      name: 'Grade Baixa',
      value: 3
    },
    {
      name: 'Grade Alta',
      value: 4
    },
    {
      name: 'Tampa',
      value: 5
    }
  ];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private paleteService: PaleteService,
    private caminhaoService: CaminhaoService,
    public swalAlert: SwalAlertService
  ) {
    this.form = this.initForm();
  }

  ngOnInit(): void {
    this.activateRoute();
  }

  initForm(): FormGroup {
    return this.fb.group({
      TX_OBSV_MOVM_PLTE: [null],
      FK_AGND: [null],
      TX_PLCA_CAVA: [null, [Validators.required, Validators.minLength(7)]],
      NM_MTRT: [null],
      QT_MOVM_PLTE: [null, [Validators.required, Validators.pattern(/^\d{1,4}$/)]],
      NU_ITEM_MOVM: [null, Validators.required],
      FK_CRRT_1: [null, Validators.required],
      FK_CRRT_2: [null],
      FK_CRRT_3: [null]
    });
  }

  postPalete(): void {
    this.isLoading = true;
    const payload = this.createPayload();
    this.paleteService
      .CreateMovimentacaoPaleteEntrada(payload, this.guid)
      .subscribe({
        next: res => {
          this.isLoading = false;
          this.router.navigate(['listagem/estacionamento-tpg']);
        },
        error: err => {
          this.isLoading = false;
        }
      });
  }

  getAgendamentoOrCavalo(): void {
    const invalidValue = ['', 0, undefined, null];
    const payload: IGetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca = {
      FK_AGND: null,
      TX_PLCA_CAVA: null
    };
    let placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    let agendamentoId = Number(this.form.controls['FK_AGND'].value);

    payload.FK_AGND = agendamentoId;

    if (!invalidValue.includes(placaCavalo))
      payload.TX_PLCA_CAVA = placaCavalo.length > 7 ? placaCavalo : null;

    this.isLoading = true;

    if (
      !invalidValue.includes(placaCavalo) ||
      !invalidValue.includes(agendamentoId)
    )
      this.caminhaoService
        .GetLastVersionCaminhaoInfoByEntradaOrAgendamentoOrPlaca(
          null,
          agendamentoId,
          placaCavalo
        )
        .subscribe({
          next: res => {
            const data = res;
            if (!data) {
              this.swalAlert.showAlert(
                'Atenção!',
                'Nenhuma informação encontrada para o agendamento ou placa informada!',
                'warning'
              );
              this.isLoading = false;
              return;
            }
            const placaCavalo = this.form.controls['TX_PLCA_CAVA'];
            if (data.FK_AGND)
              this.form.controls['FK_AGND'].setValue(data.FK_AGND);

            placaCavalo.value !== data.TX_PLCA_CAVA
              ? placaCavalo.setValue(data.TX_PLCA_CAVA)
              : null;
            if (!this.isViewing) {
              this.form.controls['NM_MTRT'].setValue(
                data.NM_USUA_MTRT ?? data.NM_MTRT
              );
              this.form.controls['NM_MTRT'].setValue(
                data.NM_USUA_MTRT ?? data.NM_MTRT
              );
            }
            this.carretaOptions = [];
            this.setCarretaOptions(data);
            this.isLoading = false;
          },
          error: err => {
            this.isLoading = false;
          }
        });
    else {
      this.isLoading = false;
      this.clearForms();
    }
  }

  createPayload(): ICreateMovimentacaoPaleteEntradaBody {
    return {
      TX_OBSV_MOVM_PLTE: this.form.controls['TX_OBSV_MOVM_PLTE'].value,
      NU_ITEM_MOVM: Number(this.form.controls['NU_ITEM_MOVM'].value),
      FK_FUNC_OPER: Number(this.id),
      FK_AGND: this.form.controls['FK_AGND'].value,
      TX_PLCA_CAVA: String(
        this.form.controls['TX_PLCA_CAVA'].value
      ).toUpperCase(),
      QT_MOVM_PLTE: this.form.controls['QT_MOVM_PLTE'].value,
      FK_CRRT_1: this.form.controls['FK_CRRT_1'].value,
      FK_CRRT_2: this.form.controls['FK_CRRT_2'].value,
      FK_CRRT_3: this.form.controls['FK_CRRT_3'].value
    };
  }

  setCarretaOptions(data: any): void {
    if (data.TX_PLCA_CRRT1) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT1,
        value: data.FK_CRRT_1
      });
    }

    if (data.TX_PLCA_CRRT2) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT2,
        value: data.FK_CRRT_2
      });
    }

    if (data.TX_PLCA_CRRT3) {
      this.carretaOptions.push({
        name: data.TX_PLCA_CRRT3,
        value: data.FK_CRRT_3
      });
    }
  }

  onCarretaChange(event: any): void {
    if (!event || !event.length) {
      this.carretasSelecionadas = 'Selecione';
      return;
    }

    this.form.controls['FK_CRRT_1'].reset();
    this.form.controls['FK_CRRT_2'].reset();
    this.form.controls['FK_CRRT_3'].reset();

    const carretasSelecionadas = this.carretaOptions
      .filter(x => event.includes(x.value))
      .map(x => x.name)
      .join(' | ');
    this.carretasSelecionadas = carretasSelecionadas;

    switch (event.length) {
      case 1:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(null);
        this.form.controls['FK_CRRT_3'].setValue(null);
        break;
      case 2:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].setValue(null);
        break;
      case 3:
        this.form.controls['FK_CRRT_1'].setValue(event[0]);
        this.form.controls['FK_CRRT_2'].setValue(event[1]);
        this.form.controls['FK_CRRT_3'].setValue(event[2]);
        break;
      default:
        break;
    }
  }

  onItemChange(event: number): void {
    if (event !== this.form.controls['NU_ITEM_MOVM'].value) {
      this.form.controls['NU_ITEM_MOVM'].setValue(event);
    }
  }

  setForms() {
    this.clearForms();
    this.getAgendamentoOrCavalo();
  }

  clearForms(): void {
    const placaCavalo = this.form.controls['TX_PLCA_CAVA'].value;
    const agendamento = this.form.controls['FK_AGND'].value;

    if (placaCavalo == '' || agendamento == '') {
      this.form.reset();
      this.initForm();
    }
  }

  activateRoute(): void {
    this.route.queryParams.subscribe(params => {
      if (params['isViewing'] === 'true') {
        this.isViewing = true;
        this.form.controls['TX_OBSV_MOVM_PLTE'].setValue(
          params['TX_OBSV_MOVM_PLTE']
        );
        this.form.controls['NM_MTRT'].setValue(params['NM_MTRT']);
        this.form.controls['QT_MOVM_PLTE'].setValue(params['QT_MOVM_PLTE']);
        this.form.controls['TX_PLCA_CAVA'].setValue(params['TX_PLCA_CAVA']);
        this.carretasSelecionadas = params['TX_PLCA_CRRT'];
        this.form.controls['FK_AGND'].setValue(params['FK_AGND']);
        this.getItemMovimentacao(String(params['TX_PLCA_CRRT']).slice(0, 7));
        this.form.disable();
      }
      this.isLoading = false;
    });
  }

  getItemMovimentacao(TX_PLCA_CRRT: string): void {
    this.isLoading = true;
    this.paleteService
      .GetMovimentacaoPaleteByPlacaCarreta(TX_PLCA_CRRT)
      .subscribe({
        next: res => {
          this.form.controls['NU_ITEM_MOVM'].setValue(res.NU_ITEM_MOVM);
          this.isLoading = false;
        },
        error: (err) => {
          if (err?.handled) {
            this.router.navigate(['listagem/estacionamento-tpg']);
            return;
          }
          this.swalAlert.showAlertOnConfirmNavigate(
            'Erro!',
            'Item da movimentação não encontrado.',
            'warning',
            'listagem/estacionamento-tpg',
            true
          );
        }
      });
  }
}
